import { defineComponent as _defineComponent } from 'vue'
import { Icons } from '@/font-awesome';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ref } from 'vue';
import CommonInput from '../components/CommonInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlusMinus',
  props: {
    amount: { type: Number, required: true },
    packageAmount: { type: Number, required: true },
    stockQuantity: { type: Number, required: true },
    style: { type: Object, required: false }
  },
  emits: ["remove-from-cart", "add-amount", "set-amount"],
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;



const showingContextMenu = ref(false);
const showingEditQuantity = ref(false);

function getAmount(i: number) {
  return (Math.floor((props.stockQuantity * i * 0.25) / props.packageAmount)) * props.packageAmount;
}

const editingValue = ref(props.amount.toString());


const __returned__ = { props, showingContextMenu, showingEditQuantity, getAmount, editingValue, get Icons() { return Icons }, get FontAwesomeIcon() { return FontAwesomeIcon }, CommonInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})